import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './user-restrictions-modal.magic.css.js';
import script from './user-restrictions-modal.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-restrictions-modal",attrs:{"part":"user-restrictions-modal","data-v-test-id":"user-restrictions-modal"}},[_c('magic-ui-text',{staticClass:"text",attrs:{"part":"text","data-v-test-id":"user-restrictions-modal-text","content":_vm.$t(_vm.content)}}),_vm._v(" "),(!_vm.isUserRestrictionCustomModalEnabled)?_c('div',{staticClass:"action",attrs:{"part":"action"}},[_c('magic-ui-button',{staticClass:"button",attrs:{"wide":"","variant":"primary","part":"button","data-v-test-id":"user-restrictions-modal-button"},domProps:{"innerHTML":_vm._s(_vm.$t('user-restrictions-modal.button'))},on:{"click":function($event){return _vm.close()}}})],1):_c('div',{staticClass:"action-custom-verify",attrs:{"part":"action-custom-verify"}},[_c('magic-router-link',{attrs:{"to":{ route: _vm.$t('user.restrictions-modal.verify-now-url')}},on:{"click":function($event){return _vm.close()}}},[_c('magic-ui-button',{staticClass:"button",attrs:{"small-extra-padding":"","no-margin":"","variant":"primary","part":"button","data-v-test-id":"user-restrictions-modal-button.verify-now"},domProps:{"innerHTML":_vm._s(_vm.$t('user-restrictions-modal-button.verify-now'))}})],1),_vm._v(" "),_c('magic-ui-button',{staticClass:"button",attrs:{"small-extra-padding":"","no-margin":"","hollow":"","variant":"secondary","part":"button","data-v-test-id":"user-restrictions-modal-button.verify-later"},domProps:{"innerHTML":_vm._s(_vm.$t('user-restrictions-modal-button.verify-later'))},on:{"click":function($event){return _vm.close()}}})],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-91b7e290_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-91b7e290";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
